module.exports = __webpack_public_path__ + "static/media/tga.0150f497.png";